import Image from "next/image";
import { Link } from "@/i18n/navigation";
import moment from "moment-timezone";
import { capitalize } from "../../../helpers/capitalize";
import { useLocale, useTranslations } from "next-intl";
import TranslateCategories from "@/components/TranslateCategories/TranslateCategories";
import { articleCoverPath } from "@/helpers/articleCover";

export default function DisplayArticle({ article }) {
    const locale = useLocale();
    const t = useTranslations();

    return (
        <div className="flex xl:flex-row flex-col gap-6 p-6 group">
            <div className="flex-1 xl:order-1 order-2">
                <div className="text-sm mb-3 font-medium">
                    <TranslateCategories
                        categories={article.categories}
                        mainCategory={article.mainCategory}
                    />
                </div>

                <Link
                    href={`/r/${article.slug}`}
                    className="block group-hover:translate-x-1 transition-transform duration-300"
                >
                    <h2 className="text-xl font-bold mb-3 text-gray-900 dark:text-white group-hover:text-primary dark:group-hover:text-primary transition-colors duration-300 line-clamp-2">
                        {article.title}
                    </h2>
                    <p className="text-gray-600 dark:text-grayDark-300 mb-4 line-clamp-3 leading-relaxed">
                        {article.description}
                    </p>
                    <div className="flex lg:flex-row flex-col lg:items-center gap-3 text-sm text-gray-500 dark:text-grayDark-400">
                        <div className="flex items-center gap-2">
                            <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>
                            {capitalize(
                                moment(article.dateCreation)
                                    .locale(locale)
                                    .fromNow(),
                            )}
                        </div>
                        <span className="text-gray-300 dark:text-grayDark-600 lg:block hidden">
                            •
                        </span>
                        <div className="flex items-center gap-2">
                            <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                />
                            </svg>
                            {t("DisplayArticle_write", {
                                fullname:
                                    article.author.pseudo &&
                                    article.author.showPseudo
                                        ? article.author.pseudo
                                        : `${article.author.firstName} ${article.author.lastName}`,
                            })}
                        </div>
                    </div>
                </Link>
            </div>

            <div className="xl:flex-shrink-0 xl:order-2 order-1">
                <Link href={`/r/${article.slug}`} className="block group">
                    <div className="xl:w-[200px] w-full aspect-[16/9] bg-gradient-to-br from-gray-100 to-gray-200 dark:from-borderDark dark:to-borderDark/50 relative rounded-lg overflow-hidden group-hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                        {/* Sa vignette, ou celle qu'on dessine a sa place :
                            sans repli, un article sans couverture passait
                            `null` a next/image et faisait tomber la ligne. */}
                        <Image
                            src={articleCoverPath(article, locale)}
                            alt={article.title}
                            fill
                            unoptimized={!article.cover}
                            className="object-cover transition-transform duration-300 group-hover:scale-110"
                        />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
                    </div>
                </Link>
            </div>
        </div>
    );
}
